import { Measurement } from "../models/measurement";
import BaseService from "./_base.service";

const endpoint = "measurements";

const MeasurementService = {
  ...BaseService<Measurement>({ endpoint })
};

export default MeasurementService;
